module.exports = __webpack_public_path__ + "static/media/search-icon-white.6e176515.svg";